import type { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { get, writable } from "svelte/store";
import cfg from "$lib/config/config";
import client from "$lib/gql/apolloClient";
import { GetCheckoutDoc } from "$lib/gql/gen/codegen";
import type { GetCheckoutQuery } from "$lib/gql/gen/codegen";
import type { BasketStore } from "./basket";
import { browser } from "$app/environment";

export type CheckoutData = {
  id: string | null;
} | null;

export function checkoutStore(
  client: ApolloClient<NormalizedCacheObject>,
  namespace: string,
  localStorage?: Storage,
) {
  let initialState = [];
  if (localStorage) {
    try {
      const checkoutString = localStorage.getItem(`${namespace}:checkout`);
      initialState = checkoutString ? JSON.parse(checkoutString) : [];
    } catch {
      initialState = [];
    }
  }
  const checkout = writable<CheckoutData>(initialState);

  if (localStorage) {
    checkout.subscribe(items => {
      localStorage.setItem(`${namespace}:checkout`, JSON.stringify(items));
    });
  }

  return {
    subscribe: checkout.subscribe,
    set: checkout.set,
    checkCheckoutStatus: async (
      basket: BasketStore,
      session: { clientIP?: string },
    ) => {
      const checkoutData = get(checkout);

      if (checkoutData && checkoutData.id) {
        try {
          const res = await client.query<GetCheckoutQuery>({
            query: GetCheckoutDoc,
            variables: {
              id: checkoutData.id,
            },
            context: {
              clientIP: session?.clientIP,
            },
          });

          if (res.data.node?.__typename === "Checkout") {
            if (res.data.node.completedAt !== null) {
              basket.clearBasket();
              checkout.set(null);
            }
          } else {
            checkout.set(null);
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
  };
}
export const checkout = checkoutStore(
  client,
  cfg.SHOPIFY_STORE + "-v2",
  browser && navigator.cookieEnabled ? localStorage : undefined,
);
